// extracted by mini-css-extract-plugin
export default {"radio_item":"RadioPart_radio_item__5SvBE","radio":"RadioPart_radio__4p9LJ","recommended":"RadioPart_recommended__hONWA","radio_desc":"RadioPart_radio_desc__SlUPi"};